import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { NavLink, HashRouter } from "react-router-dom";

import { ConnectionTypes } from "../../components/Utils";

import { CancelButtonLink } from "../../../../components/Buttons";
import Dashboard from "../../../../components/Dashboard";
import ImportForm from "../../../../components/ImportForm";
import {
  WizardTitle,
  notifyError,
  PageHeightAuto,
  notifyInfo,
} from "../../../../components/Utils";

const Wizard = ({ type, history }) => {
  const [imported, setImported] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [importSuccess, setImportSuccess] = useState(false);

  useEffect(() => {
    if (importSuccess) {
      const summary =
        type === "AD"
          ? "Vodafone Accountimport"
          : `${type}-Zugangsimport`;
      const name =
        type === "AD"
          ? "Vodafone Accounts"
          : `${type}-Zugänge`;
      const timer = setTimeout(() => {
        notifyInfo({
          summary,
          detail: `Die ${name} wurden erfolgreich importiert.`,
        });
        handleCancel();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [importSuccess, type]);

  const handleError = useCallback((event) => {
    const error = event.xhr.response;
    const errorMessage = error && error.message;
    notifyError({
      summary: "Importfehler",
      detail: errorMessage,
    });
    setImported([]);
    setRejected([]);
  }, []);

  const handleSuccess = useCallback((event) => {
    console.log("Import succeeded:", event);
    setImportSuccess(true);
  }, []);

  const handleCancel = useCallback(() => {
    history.push("/aufgaben/it-zugaenge");
  }, [history]);

  const renderMenu = () => {
    let rejectedLink;
    if (rejected.length !== 0) {
      rejectedLink = (
        <li>
          <NavLink to={`/abgelehnt`} activeClassName="active">
            {"Abgelehnte Zugänge"}
          </NavLink>
        </li>
      );
    }
    let importedLink;
    if (imported.length !== 0) {
      importedLink = (
        <li>
          <NavLink to={`/importiert`} activeClassName="active">
            {"Importierte Zugänge"}
          </NavLink>
        </li>
      );
    }
    return (
      <HashRouter>
        <div className="under-wizard-title">
          <div className="margin-big-top nav-menu-vertical">
            <ul className="w3-ul w3-border w3-round- w3-large">
              <li>
                <NavLink to={`/upload`} activeClassName="active">
                  {"CSV hochladen"}
                </NavLink>
              </li>
              {rejectedLink}
              {importedLink}
            </ul>
          </div>
        </div>
      </HashRouter>
    );
  };

  console.log(
    "ConnectionImportWizard.render() \nprops",
    { type },
    "\nstate",
    { imported, rejected, importSuccess },
  );
  const Menu = renderMenu();

  let rejectedSection;
  if (rejected.length !== 0) {
    rejectedSection = (
      <PageHeightAuto
        id="/abgelehnt"
        className="w3-border margin-big-top pad-big"
      >
        <h3 className="no-margin-top">Abgelehnte Zugänge</h3>
      </PageHeightAuto>
    );
  }

  let importedSection;
  if (imported.length !== 0) {
    importedSection = (
      <PageHeightAuto
        id="/importiert"
        className="w3-border margin-big-top pad-big"
      >
        <h3 className="no-margin-top">Importierte Zugänge</h3>
      </PageHeightAuto>
    );
  }

  return (
    <div className="clearfix">
      <WizardTitle
        type={`connection-import-${type.toLowerCase()}`}
        menu={
          <div className="pad-big-top">
            <CancelButtonLink onCancel={handleCancel} />
          </div>
        }
      />
      <div className="container">
        <Dashboard menu={Menu} menuSize={3}>
          <PageHeightAuto
            id="/upload"
            className="w3-border margin-big-top pad-big"
          >
            <h3 className="no-margin-top">CSV hochladen</h3>
            <ImportForm
              url={`/data-api/companies/connections/csv/upload/${type}`}
              onError={handleError}
              onUpload={handleSuccess}
            />
          </PageHeightAuto>
          {rejectedSection}
          {importedSection}
        </Dashboard>
      </div>
    </div>
  );
};

Wizard.propTypes = {
  type: PropTypes.oneOf([
    ConnectionTypes.IT_CONNECTION,
    ConnectionTypes.PT_CONNECTION,
    ConnectionTypes.AD_CONNECTION,
    ConnectionTypes.DELPHI_CONNECTION,
  ]).isRequired,
  history: PropTypes.object,
};

export default Wizard;
